import React from "react";
import Table from "react-bootstrap/Table";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { debounce } from "debounce";
import { VscFilePdf } from "react-icons/vsc";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { LOCALES } from "common/constants";

const HolidayPayAmount = ({
  spinner,
  date,
  incomeData,
  isPayShow,
  hideNote,
  toolTipError,
  handlePayAmountChange,
  t,
  setPayShow,
  payOutAmount,
  handlePayOutAmout,
  setShow,
}) => {
  const language = localStorage.getItem("i18nextLng");
  const navigate = useNavigate();

  return (
    <div className="w-100 mt-4 table-div">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>
              {spinner.spinner && date.from && date.to
                ? t("Loading Holiday Pay Balance")
                : spinner.spinner
                ? `${t("Loading Holiday Pay Balance For ")} ${spinner.Year}`
                : date.from || date.to
                ? t("Holiday Pay Balance")
                : `${t("Holiday Pay Balance")}`}
            </th>
            <th style={{ minWidth: "52px" }}>{t("Action")}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="semester">
              <span className="font-weight-bold"> {t("Balance Left")} </span>

              {spinner.spinner ? (
                <div
                  className="spinner-border text-primary spinner-border-sm"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (date.from || date.to) && !incomeData.usingDates ? (
                t("Please select the dates and click on the download button")
              ) : incomeData.values?.holidaySavingsAmount ? (
                incomeData.values?.holidaySavingsAmount + " SEK"
              ) : incomeData.statusCode === 400 ? (
                t("Found an Error")
              ) : incomeData.statusCode === 200 &&
                !incomeData.values?.holidaySavingsAmount ? (
                t("No data found")
              ) : (
                t("Click Download to see data")
              )}
              <div className="btn-group-table">
              <Button
                className="ml-3 mb-2 pay_out"
                onClick={() => setPayShow((prev) => !prev)}
              >
                {t("Pay Out")}
              </Button>
              <Button
                className="ml-3 mb-2 trans_history "
                onClick={() =>
                  navigate(
                    language === LOCALES.EN_US
                      ? `/dashboard/economy/salaries?lang=${LOCALES.EN_US}`
                      : `/instrumentbrada/ekonomi/loner?lang=${LOCALES.SV_SE}`,
                    { state: true }
                  )
                }
              >
                {t("See Payout History")}
              </Button>
              </div>
              {isPayShow && (
                <>
                  {!hideNote && (
                    <p className="mb-0 note-text">
                      {t(
                        "Note: 190 SEK will be deducted from each vacation payout."
                      )}
                    </p>
                  )}
                  <div className="form-group">
                    <OverlayTrigger
                      show={toolTipError.lessPayAmount}
                      placement="top"
                      overlay={
                        <Popover
                          id={`popover-positioned-top`}
                          style={{ margin: 0 }}
                        >
                          <Popover.Header className="text-danger" as="h3">
                            {toolTipError.lessPayAmount &&
                              t(
                                payOutAmount >
                                  incomeData.values?.holidaySavingsAmount
                                  ? t(
                                      "Pay out Amount should be less than holiday savings amount"
                                    )
                                  : t("Please Enter Amount Above 1000 SEK")
                              )}
                          </Popover.Header>
                        </Popover>
                      }
                    >
                      <input
                        className="form-control  mb-0 mt-2 w-50 d-inline-block"
                        placeholder={t("Enter Pay Out Amount")}
                        type="number"
                        step="1"
                        min="1000"
                        disabled={!incomeData.values?.holidaySavingsAmount}
                        // max="13"
                        onKeyUp={(object) => {
                          if (object.target.value <= 0)
                            object.target.value = "";
                          // else if (object.target.value > 13) object.target.value = 13;
                        }}
                        onChange={debounce(async (e) => {
                          handlePayAmountChange(e);
                        }, 500)}
                      />
                    </OverlayTrigger>
                    <Button
                      className="ml-3 mb-1 theme_btn"
                      disabled={!incomeData.values?.holidaySavingsAmount}
                      onClick={handlePayOutAmout}
                    >
                      {t("Pay")}
                    </Button>
                  </div>
                </>
              )}
            </td>

            <td>
              <div className="pdfIcon">
                <VscFilePdf
                  title={t("Download PDF")}
                  onClick={() => {
                    if (
                      incomeData.statusCode === 200 &&
                      incomeData.values &&
                      incomeData.values.pensionAmount
                    ) {
                      setShow({ PDFModal: true });
                    } else if (incomeData.statusCode === 200) {
                      toast.error(t(`${t("No data found")}`));
                    } else {
                      toast.error(
                        t(
                          "Please click the download button to download the data"
                        )
                      );
                    }
                  }}
                  size={30}
                />
              </div>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default HolidayPayAmount;
